import IconContainer from "./IconContainer"
import { IconProps } from "./IconUtilities"

const IconSmiley: React.FC<IconProps> = ({ className, size, contained }) => {
	if (contained) {
		return (
			<IconContainer
				className={className}
				size={size}
			>
				<path d="M7.4925 0C3.3525 0 0 3.36 0 7.5C0 11.64 3.3525 15 7.4925 15C11.64 15 15 11.64 15 7.5C15 3.36 11.64 0 7.4925 0ZM7.5 13.5C4.185 13.5 1.5 10.815 1.5 7.5C1.5 4.185 4.185 1.5 7.5 1.5C10.815 1.5 13.5 4.185 13.5 7.5C13.5 10.815 10.815 13.5 7.5 13.5ZM10.125 6.75C10.7475 6.75 11.25 6.2475 11.25 5.625C11.25 5.0025 10.7475 4.5 10.125 4.5C9.5025 4.5 9 5.0025 9 5.625C9 6.2475 9.5025 6.75 10.125 6.75ZM4.875 6.75C5.4975 6.75 6 6.2475 6 5.625C6 5.0025 5.4975 4.5 4.875 4.5C4.2525 4.5 3.75 5.0025 3.75 5.625C3.75 6.2475 4.2525 6.75 4.875 6.75ZM7.5 11.625C9.2475 11.625 10.7325 10.53 11.3325 9H3.6675C4.2675 10.53 5.7525 11.625 7.5 11.625Z" />
			</IconContainer>
		)
	}
	return (
		<path d="M7.4925 0C3.3525 0 0 3.36 0 7.5C0 11.64 3.3525 15 7.4925 15C11.64 15 15 11.64 15 7.5C15 3.36 11.64 0 7.4925 0ZM7.5 13.5C4.185 13.5 1.5 10.815 1.5 7.5C1.5 4.185 4.185 1.5 7.5 1.5C10.815 1.5 13.5 4.185 13.5 7.5C13.5 10.815 10.815 13.5 7.5 13.5ZM10.125 6.75C10.7475 6.75 11.25 6.2475 11.25 5.625C11.25 5.0025 10.7475 4.5 10.125 4.5C9.5025 4.5 9 5.0025 9 5.625C9 6.2475 9.5025 6.75 10.125 6.75ZM4.875 6.75C5.4975 6.75 6 6.2475 6 5.625C6 5.0025 5.4975 4.5 4.875 4.5C4.2525 4.5 3.75 5.0025 3.75 5.625C3.75 6.2475 4.2525 6.75 4.875 6.75ZM7.5 11.625C9.2475 11.625 10.7325 10.53 11.3325 9H3.6675C4.2675 10.53 5.7525 11.625 7.5 11.625Z" />
	)
}

export default IconSmiley
